import { Airport } from "shared/types/airportsTypes";

export const nationalData: Airport[] = [
  {
    description: "Belém - Val De Cans (BEL), Brasil",
    name: "Belém",
    code: "BEL",
  },
  {
    description: "Belo Horizonte - Todos os aeroportos (BHZ), Brasil",
    name: "Belo Horizonte",
    code: "BHZ",
  },
  {
    description: "Brasília - Brasília Intl (BSB), Brasil",
    name: "Brasília",
    code: "BSB",
  },
  {
    description: "Campo Grande - Campo Grande Intl (CGR), Brasil",
    name: "Campo Grande",
    code: "CGR",
  },
  {
    description: "Cuiabá - M Rondon (CGB), Brasil",
    name: "Cuiabá",
    code: "CGB",
  },
  {
    description: "Curitiba - Afonso Pena (CWB), Brasil",
    name: "Curitiba",
    code: "CWB",
  },
  {
    description: "Florianópolis - Hercílio Luz (FLN), Brasil",
    name: "Florianópolis",
    code: "FLN",
  },
  {
    description: "Fortaleza - Pinto Martins (FOR), Brasil",
    name: "Fortaleza",
    code: "FOR",
  },
  {
    description: "Foz do Iguaçú - Cataratas (IGU), Brasil",
    name: "Foz do Iguaçu",
    code: "IGU",
  },
  {
    description: "João Pessoa - Castro Pinto (JPA), Brasil",
    name: "João Pessoa",
    code: "JPA",
  },
  {
    description: "Juazeiro do Norte - Regional Do Cariri (JDO), Brasil",
    name: "Juazeiro do Norte",
    code: "JDO",
  },
  {
    description: "Maceió - Palmares (MCZ), Brasil",
    name: "Maceió",
    code: "MCZ",
  },
  {
    description: "Manaus - Eduardo Gomes (MAO), Brasil",
    name: "Manaus",
    code: "MAO",
  },
  {
    description: "Natal - Governador Aluízio Alves Intl (NAT), Brasil",
    name: "Natal",
    code: "NAT",
  },
  {
    description: "Porto Alegre - Salgado Filho (POA), Brasil",
    name: "Porto Alegre",
    code: "POA",
  },
  {
    description: "Porto Seguro - Porto Seguro (BPS), Brasil",
    name: "Porto Seguro",
    code: "BPS",
  },
  {
    description: "Porto Velho - Belmonte (PVH), Brasil",
    name: "Porto Velho",
    code: "PVH",
  },
  {
    description: "Recife - Guararapes Intl (REC), Brasil",
    name: "Recife",
    code: "REC",
  },
  {
    description: "Rio Branco - Plácido de Castro (RBR), Brasil",
    name: "Rio Branco",
    code: "RBR",
  },
  {
    description: "Rio de Janeiro - Todos os aeroportos (RIO), Brasil",
    name: "Rio de Janeiro",
    code: "RIO",
  },
  {
    description: "Salvador - Dep. Luís Eduardo Magalhães (SSA), Brasil",
    name: "Salvador",
    code: "SSA",
  },
  {
    description: "São Luís - Tirirical (SLZ), Brasil",
    name: "São Luís",
    code: "SLZ",
  },
  {
    description: "São Paulo - Todos os aeroportos (SAO), Brasil",
    name: "São Paulo",
    code: "SAO",
  },
  {
    description: "Teresina - Teresina (THE), Brasil",
    name: "Teresina",
    code: "THE",
  },
];
